<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncGruposPrecios()"
      v-if="!loading"
    >
      Sync Grupos precios
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <table class="default-table text-center my-6" v-else>
      <thead>
        <th>ID</th>
        <th>Grupo Precio ID</th>
        <th>Codigo</th>
        <th>Descripcion</th>
        <th>Valor Web</th>
        <th>Departamento</th>
      </thead>
      <tbody>
        <tr v-for="grupo in gruposPrecios" :key="grupo.id">
          <td>{{ grupo.id }}</td>
          <td>{{ grupo.grupoPrecioId }}</td>
          <td>{{ grupo.codigo }}</td>
          <td>{{ grupo.descripcion }}</td>
          <td>{{ grupo.codigoWeb }}</td>
          <td>{{ grupo.departamentoNombre || "-" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { getPriceGroups, getSyncPriceGroups } from "@/api/Infoauto.js";
export default {
  name: "Depositos",
  data() {
    return {
      gruposPrecios: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.gruposPrecios = await getPriceGroups();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncGruposPrecios() {
      this.loading = true;
      try {
        this.gruposPrecios = await getSyncPriceGroups();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
